import ContentArea from 'components/content-area/ContentArea';
import ContentContainer from 'components/content-container/ContentContainer';
import PageHeader from 'components/page-header/PageHeader';
import PortfolioHeader from 'components/portfolio-header/PortfolioHeader';
import { htmlThemes } from 'components/html-string/HtmlString';

import { IContentAreaPage } from 'source/NFR.types';

const narrowTextProps = {
  HtmlString: { theme: htmlThemes.narrow }
};

const ContentAreaPage: React.FC<IContentAreaPage> = ({ content, pageHeader, portfolioHeader }) => (
  <div className="content-area-page">
    {portfolioHeader && <PortfolioHeader {...portfolioHeader} isPageHeader />}
    {pageHeader && <PageHeader {...pageHeader} />}
    <ContentContainer className="content-area-page--content">
      <ContentArea
        additionalComponentProps={{
          ...narrowTextProps,
          // NOTE: RichText is just a proxy for ContentArea, so themes need to be applied using additionalComponentProps
          RichText: { additionalComponentProps: narrowTextProps }
        }}
        {...content}
      />
    </ContentContainer>
  </div>
);

ContentAreaPage.displayName = 'ContentAreaPage';

export default ContentAreaPage;
